export default __webpack_public_path__ + "static/media/Tamara's Corsair Cache.8a604c48.jpg";